export var ChargerAssetLinkResponse;
(function (ChargerAssetLinkResponse) {
    /**
     * The current status of the charger.
     */
    let status;
    (function (status) {
        status["ACTIVE"] = "ACTIVE";
        status["DEACTIVATED"] = "DEACTIVATED";
        status["EXPIRED"] = "EXPIRED";
    })(status = ChargerAssetLinkResponse.status || (ChargerAssetLinkResponse.status = {}));
})(ChargerAssetLinkResponse || (ChargerAssetLinkResponse = {}));
